<template>
  <div class="avatar-swiper">
    <Swiper
      :modules="swiperConfiguration.modules"
      :breakpoints="swiperConfiguration.breakpoints"
      :loop="swiperConfiguration.loop"
      :grab-cursor="swiperConfiguration.grapCursor"
      :centered-slides="swiperConfiguration.centeredSlides"
      :slides-per-view="swiperConfiguration.slidesPerView"
      :space-between="swiperConfiguration.spaceBetween"
      :navigation="swiperConfiguration.navigation"
      @swiper="handleSwiperInit"
    >
      <SwiperSlide
        v-for="avatar in avatarList"
        :key="avatar.id"
        @click="handleAvatarSelect(avatar.image)"
      >
        <div class="carousel-item">
          <div :class="['user_img_bg', {selected: modelValue === avatar.image}]">
            <BaseImage :src="avatar.image" :alt="'Avatar ' + avatar.id" />
          </div>
        </div>
      </SwiperSlide>
    </Swiper>

    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script setup>
import 'swiper/css/navigation';

import { computed } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import BaseImage from '@/components/image/BaseImage.vue';

const swiperConfigurationCommon = {
  modules: [Navigation],
  loop: true,
  grapCursor: true,
  centeredSlides: false,
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
};

const swiperConfigurationPerType = {
  profile: {
    slidesPerView: 3,
    breakpoints: {
      600: { slidesPerView: 4, spaceBetween: 10, centeredSlides: false },
      360: { slidesPerView: 3, spaceBetween: 10, centeredSlides: true },
      0: { slidesPerView: 2, spaceBetween: 10, centeredSlides: true },
    },
  },
  register: {
    breakpoints: {
      510: { slidesPerView: 3, spaceBetween: 10, centeredSlides: true },
      370: { slidesPerView: 2, spaceBetween: 10, centeredSlides: true },
    },
  },
};

const avatarList = Array.from({ length: 30 }, (_empty, index) => {
  const id = index + 1;

  return {
    id,
    image: `/static/images/avatars/avatar_${ id.toString().padStart(2, '0') }.svg`,
  };
});

const emits = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'profile',
    validator: (value) => ['profile', 'register'].includes(value),
  },
});

const swiperConfiguration = computed(() => ({
  ...swiperConfigurationCommon,
  ...(swiperConfigurationPerType[props.type] || {}),
}));

const handleSwiperInit = (swiper) => {
  const findIndex = avatarList.findIndex(({ image }) => image === props.modelValue);

  if (findIndex > -1) {
    swiper.slideToLoop(findIndex, 0, true);
  } else {
    swiper.slideToLoop(0, 0, true);
  }
};

const handleAvatarSelect = (avatar) => {
  if (props.modelValue === avatar) { return; }

  emits('update:modelValue', avatar);
};
</script>
